import i18n from 'i18nextInstance';
import orderBy from 'lodash/orderBy';
import { push } from 'react-router-redux';
import { videoconferenceActions } from './';
import videoconferenceServices from './services';
import {
    call,
    put,
    takeEvery
} from 'redux-saga/effects';

function* _createVideoconference ({ payload }) {
    try {
        yield put(videoconferenceActions.setVideoconferenceStatus('creating'));
        yield call(videoconferenceServices.postVideoconference, null, payload);
        yield put(push(i18n.t('/videoconferencia/listar')));
    } catch (err) {

    } finally {
        yield put(videoconferenceActions.setVideoconferenceStatus(''));
    }
}

function* _deleteVideoconference ({ payload: id }) {
    try {
        yield put(videoconferenceActions.setVideoconferenceStatus('deleting'));
        yield call(videoconferenceServices.deleteVideoconference, { id });
        yield put(push(i18n.t('/videoconferencia/listar')));
    } catch (err) {

    } finally {
        yield put(videoconferenceActions.setVideoconferenceStatus(''));
    }
}

function* _editVideoconference ({ payload: { data, id } }) {
    try {
        yield put(videoconferenceActions.setVideoconferenceStatus('editing'));
        yield call(videoconferenceServices.updateVideoconference, { id }, data);
        yield put(push(i18n.t('/videoconferencia/listar')));
    } catch (err) {

    } finally {
        yield put(videoconferenceActions.setVideoconferenceStatus(''));
    }
}

function* _getVideoconference ({ payload: id }) {
    try {
        yield put(videoconferenceActions.setVideoconferenceStatus('loading'));
        const { data } = yield call(videoconferenceServices.fetchVideoconference, { id });
        yield put(videoconferenceActions.setVideoconferenceVideoconference(data));
    } catch (err) {
        yield put(videoconferenceActions.setVideoconferenceVideoconference({}));
    } finally {
        yield put(videoconferenceActions.setVideoconferenceStatus(''));
    }
}

function* _getVideoconferenceList () {
    try {
        yield put(videoconferenceActions.setVideoconferenceStatus('loading'));
        const { data } = yield call(videoconferenceServices.fetchVideoconferences);
        yield put(videoconferenceActions.setVideoconferenceList(orderBy(data, ['start_date_time'], ['desc'])));
    } catch (err) {
        yield put(videoconferenceActions.setVideoconferenceList([]));
    } finally {
        yield put(videoconferenceActions.setVideoconferenceStatus(''));
    }
}

export default [
    takeEvery(videoconferenceActions.createVideoconference.type, _createVideoconference),
    takeEvery(videoconferenceActions.deleteVideoconference.type, _deleteVideoconference),
    takeEvery(videoconferenceActions.editVideoconference.type, _editVideoconference),
    takeEvery(videoconferenceActions.getVideoconference.type, _getVideoconference),
    takeEvery(videoconferenceActions.getVideoconferenceList.type, _getVideoconferenceList)
];
